import { useMutation } from "@tanstack/react-query";
import { updateFloorPlanMemoText } from "~/_legacy/apis/update-floor-plan-memo-text";
import { isNullish } from "~/_legacy/utils/compare";

export const UPDATE_FLOOR_PLAN_MEMO_TEXT_MUTATION_KEY = "updateFloorPlanMemoText";

export function useUpdateFloorPlanMemoText({
  branchUid,
  branchVersionId,
}: {
  branchUid?: string;
  branchVersionId?: number;
}) {
  const { mutateAsync } = useMutation({
    mutationKey: [UPDATE_FLOOR_PLAN_MEMO_TEXT_MUTATION_KEY, branchUid, branchVersionId],
    mutationFn: ({
      floorPlanId,
      memoTextId,
      content,
      position,
      style,
    }: {
      floorPlanId: number;
      memoTextId: number;
      content: string;
      position: { x: number; y: number };
      style: {
        color: string;
        width: number;
        opacity: number;
        fontSize: number;
        hasStroke: boolean;
        rotation?: number;
      };
    }) => {
      if (isNullish(branchUid)) {
        throw new Error("Branch uid가 필요합니다.");
      }
      return updateFloorPlanMemoText({
        branchUid,
        branchVersionId,
        floorPlanId,
        memoTextId,
        content,
        position,
        style,
      });
    },
  });

  return {
    updateFloorPlanMemoText: mutateAsync,
  };
}
